import React from 'react';
import { Link } from 'react-router-dom';

const BulkSmsModules = () => {
  return (
    <section id="bulk-sms-modules" className="py-16 bg-gradient-to-br from-blue-600 to-blue-800">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            BULK SMS MODULES
          </h2>
          <p className="text-blue-100 text-lg max-w-3xl mx-auto">
            Powerful SMS solutions designed to streamline your communication across Kenya, Tanzania, Uganda, and Ghana
          </p>
        </div>

        {/* Modules Grid */}
        <div className="grid md:grid-cols-2 gap-8 max-w-7xl mx-auto">
          
          {/* Transactional SMS Module */}
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden hover:transform hover:scale-105 transition-all duration-300">
            <div className="relative">
              <img 
                src="/assets/transactionalsms.png" 
                alt="Transactional SMS Service" 
                className="w-full h-64 object-cover"
              />
              <div className="absolute top-4 left-4 bg-blue-600 text-white px-3 py-1 rounded-full text-sm font-semibold">
                INSTANT DELIVERY
              </div>
            </div>
            
            <div className="p-8">
              <h3 className="text-2xl font-bold text-gray-800 mb-3">
                Transactional SMS – Reliable & Instant Notifications
              </h3>
              <p className="text-blue-600 font-semibold mb-4 text-lg">
                Keep your customers informed, every step of the way.
              </p>
              
              <p className="text-gray-600 mb-6 leading-relaxed">
                At Infinity Tech Africa, we deliver Transactional SMS services in Kenya, Tanzania, Uganda, and Ghana that ensure real-time, secure, and seamless communication. From order confirmations and payment alerts to OTP SMS and appointment reminders, our SMS API platform guarantees instant message delivery through direct telco integrations.
              </p>

              <div className="mb-6">
                <h4 className="font-bold text-gray-800 mb-3">Why Choose Infinity Tech Africa for Transactional SMS?</h4>
                <div className="space-y-2">
                  <div className="flex items-start">
                    <span className="text-green-500 mr-2 text-lg">✔</span>
                    <span className="text-gray-700"><strong>High Deliverability</strong> – Direct operator routes with 99% success rates.</span>
                  </div>
                  <div className="flex items-start">
                    <span className="text-green-500 mr-2 text-lg">✔</span>
                    <span className="text-gray-700"><strong>Low Latency</strong> – Critical notifications delivered within seconds.</span>
                  </div>
                  <div className="flex items-start">
                    <span className="text-green-500 mr-2 text-lg">✔</span>
                    <span className="text-gray-700"><strong>Scalable & Secure</strong> – Built for banks, fintech, e-commerce, healthcare, and logistics.</span>
                  </div>
                  <div className="flex items-start">
                    <span className="text-green-500 mr-2 text-lg">✔</span>
                    <span className="text-gray-700"><strong>Regulatory Compliance</strong> – Licensed by the Communications Authority of Kenya.</span>
                  </div>
                </div>
              </div>

              <p className="text-blue-600 font-semibold mb-6">
                Never miss a beat. With automated SMS notifications, you keep customers updated, build trust, and enhance every interaction.
              </p>

              <Link
                to="https://sms.infinitytechafrica.com/#/signup"  // Make sure this matches your registration route
                className="inline-flex items-center justify-center w-full bg-gradient-to-r from-blue-600 to-green-600 text-white py-3 px-6 rounded-lg font-semibold hover:from-blue-700 hover:to-green-700 shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 ease-in-out"
              >
                <span>Get Started with Transactional SMS</span>
                <svg 
                  className="w-5 h-5 ml-2 transform group-hover:translate-x-1 transition-transform duration-300" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6"></path>
                </svg>
              </Link>
            </div>
          </div>

          {/* Broadcast SMS Module */}
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden hover:transform hover:scale-105 transition-all duration-300">
            <div className="relative">
              <img 
                src="/assets/broadcastsms.png" 
                alt="Broadcast SMS Service" 
                className="w-full h-64 object-cover"
              />
              <div className="absolute top-4 left-4 bg-green-600 text-white px-3 py-1 rounded-full text-sm font-semibold">
                MASS REACH
              </div>
            </div>
            
            <div className="p-8">
              <h3 className="text-2xl font-bold text-gray-800 mb-3">
                Broadcast SMS – Reach Thousands Instantly
              </h3>
              <p className="text-green-600 font-semibold mb-4 text-lg">
                Mass messaging made simple, fast, and effective.
              </p>
              
              <p className="text-gray-600 mb-6 leading-relaxed">
                Need to share promotions, announcements, or urgent updates with a large audience? Our Broadcast SMS service helps you connect with thousands of customers across Kenya, Tanzania, Uganda, and Ghana in just seconds. Perfect for SMS marketing campaigns, event alerts, emergency notifications, and branded bulk messaging.
              </p>

              <div className="mb-6">
                <h4 className="font-bold text-gray-800 mb-3">Why Choose Infinity Tech Africa for Broadcast SMS?</h4>
                <div className="space-y-2">
                  <div className="flex items-start">
                    <span className="text-green-500 mr-2 text-lg">✔</span>
                    <span className="text-gray-700"><strong>Wide Coverage</strong> – Direct partnerships with leading telcos ensure maximum reach and reliability.</span>
                  </div>
                  <div className="flex items-start">
                    <span className="text-green-500 mr-2 text-lg">✔</span>
                    <span className="text-gray-700"><strong>Easy Scheduling</strong> – Send messages immediately or schedule them in advance with our intuitive dashboard.</span>
                  </div>
                  <div className="flex items-start">
                    <span className="text-green-500 mr-2 text-lg">✔</span>
                    <span className="text-gray-700"><strong>Cost-Effective</strong> – Competitive bulk SMS rates tailored for SMEs, enterprises, NGOs, and institutions.</span>
                  </div>
                  <div className="flex items-start">
                    <span className="text-green-500 mr-2 text-lg">✔</span>
                    <span className="text-gray-700"><strong>Scalable & Flexible</strong> – From small campaigns to nationwide broadcasts, no audience is too big.</span>
                  </div>
                </div>
              </div>

              <p className="text-green-600 font-semibold mb-6">
                Turn every SMS into impact: boost engagement, grow your reach, and keep customers connected with Infinity Tech Africa's bulk SMS platform.
              </p>

              <Link
                to="https://sms.infinitytechafrica.com/#/signup"
                className="inline-flex items-center justify-center w-full bg-gradient-to-r from-blue-600 to-green-600 text-white py-3 px-6 rounded-lg font-semibold hover:from-blue-700 hover:to-green-700 shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 ease-in-out"
              >
                <span>Start Broadcasting Today</span>
                <svg 
                  className="w-5 h-5 ml-2 transform group-hover:translate-x-1 transition-transform duration-300" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6"></path>
                </svg>
              </Link>
            </div>
          </div>

          {/* Survey SMS Module */}
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden hover:transform hover:scale-105 transition-all duration-300">
            <div className="relative">
              <img 
                src="/assets/surveysms.png" 
                alt="Survey SMS Service" 
                className="w-full h-64 object-cover"
              />
              <div className="absolute top-4 left-4 bg-purple-600 text-white px-3 py-1 rounded-full text-sm font-semibold">
                REAL-TIME FEEDBACK
              </div>
            </div>
            
            <div className="p-8">
              <h3 className="text-2xl font-bold text-gray-800 mb-3">
                Survey SMS – Gather Insights in Real Time
              </h3>
              <p className="text-purple-600 font-semibold mb-4 text-lg">
                Listen, Learn, and Grow with Instant Feedback.
              </p>
              
              <p className="text-gray-600 mb-6 leading-relaxed">
                Listening, learning, and growing with instant customer feedback is the best way to understand your customers better.
                With Infinity Tech Africa's Survey SMS platform, you can run mobile surveys, quick polls, and feedback campaigns that deliver responses within minutes. Designed for market research, customer satisfaction surveys, and event evaluations, our solution empowers businesses across Kenya, Tanzania, Uganda, and Ghana to make smarter, data-driven decisions.
              </p>

              <div className="mb-6">
                <h4 className="font-bold text-gray-800 mb-3">Why Choose SMS Surveys?</h4>
                <div className="space-y-2">
                  <div className="flex items-start">
                    <span className="text-green-500 mr-2 text-lg">✔</span>
                    <span className="text-gray-700"><strong>High Engagement Rate</strong> – SMS surveys achieve up to 3 times higher response rates than email.</span>
                  </div>
                  <div className="flex items-start">
                    <span className="text-green-500 mr-2 text-lg">✔</span>
                    <span className="text-gray-700"><strong>Fast & Simple</strong> – Run surveys in minutes with no apps or downloads required.</span>
                  </div>
                  <div className="flex items-start">
                    <span className="text-green-500 mr-2 text-lg">✔</span>
                    <span className="text-gray-700"><strong>Real-Time Analytics</strong> – Monitor responses instantly and generate actionable reports.</span>
                  </div>
                  <div className="flex items-start">
                    <span className="text-green-500 mr-2 text-lg">✔</span>
                    <span className="text-gray-700"><strong>Scalable</strong> – Reach a handful of clients or thousands nationwide with ease.</span>
                  </div>
                </div>
              </div>

              <p className="text-purple-600 font-semibold mb-6">
                SMS surveys help you unlock valuable insights straight from your customers' phones and turn feedback into growth with Infinity Tech Africa's SMS survey solution.
              </p>

              <Link
                to="https://sms.infinitytechafrica.com/#/signup"
                className="inline-flex items-center justify-center w-full bg-gradient-to-r from-blue-600 to-green-600 text-white py-3 px-6 rounded-lg font-semibold hover:from-blue-700 hover:to-green-700 shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 ease-in-out"
              >
                <span>Launch Your SMS Survey</span>
                <svg 
                  className="w-5 h-5 ml-2 transform group-hover:translate-x-1 transition-transform duration-300" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6"></path>
                </svg>
              </Link>
            </div>
          </div>

          {/* Voting SMS Module */}
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden hover:transform hover:scale-105 transition-all duration-300">
            <div className="relative">
              <img 
                src="/assets/votingsms.png" 
                alt="Voting SMS Service" 
                className="w-full h-64 object-cover"
              />
              <div className="absolute top-4 left-4 bg-orange-600 text-white px-3 py-1 rounded-full text-sm font-semibold">
                LIVE POLLS
              </div>
            </div>
            
            <div className="p-8">
              <h3 className="text-2xl font-bold text-gray-800 mb-3">
                Voting SMS – Engage Audiences with Live Polls
              </h3>
              <p className="text-orange-600 font-semibold mb-4 text-lg">
                Powering fair, fast, and transparent voting experiences.
              </p>
              
              <p className="text-gray-600 mb-6 leading-relaxed">
                From TV shows, competitions, and reality contests to corporate elections, SACCO AGMs, and organisational polls, Infinity Tech Africa's Voting SMS platform offers a secure, scalable, and transparent way to engage audiences. With direct telco integrations across Kenya, Tanzania, Uganda, and Ghana, we ensure every vote counts without delays or fraud.
              </p>

              <div className="mb-6">
                <h4 className="font-bold text-gray-800 mb-3">Why Choose Our SMS Voting Solution?</h4>
                <div className="space-y-2">
                  <div className="flex items-start">
                    <span className="text-green-500 mr-2 text-lg">✔</span>
                    <span className="text-gray-700"><strong>Instant Results</strong> – Real-time vote tallying and dashboards for live events.</span>
                  </div>
                  <div className="flex items-start">
                    <span className="text-green-500 mr-2 text-lg">✔</span>
                    <span className="text-gray-700"><strong>Fraud Prevention</strong> – Secure shortcodes, verification mechanisms, and audit trails.</span>
                  </div>
                  <div className="flex items-start">
                    <span className="text-green-500 mr-2 text-lg">✔</span>
                    <span className="text-gray-700"><strong>Wide Accessibility</strong> – No internet required since any phone with SMS can participate.</span>
                  </div>
                  <div className="flex items-start">
                    <span className="text-green-500 mr-2 text-lg">✔</span>
                    <span className="text-gray-700"><strong>Scalable & Reliable</strong> – Designed for everything from small polls to national events.</span>
                  </div>
                </div>
              </div>

              <p className="text-orange-600 font-semibold mb-6">
                Make every voice heard with Infinity Tech Africa's trusted SMS voting system, where participation is simple, secure, and transparent.
              </p>

              <Link
                to="https://sms.infinitytechafrica.com/#/signup"
                className="inline-flex items-center justify-center w-full bg-gradient-to-r from-blue-600 to-green-600 text-white py-3 px-6 rounded-lg font-semibold hover:from-blue-700 hover:to-green-700 shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 ease-in-out"
              >
                <span>Set Up Your Voting System</span>
                <svg 
                  className="w-5 h-5 ml-2 transform group-hover:translate-x-1 transition-transform duration-300" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6"></path>
                </svg>
              </Link>
            </div>
          </div>

        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 max-w-4xl mx-auto border border-white/20">
            <h3 className="text-2xl font-bold text-white mb-4">
              Ready to Transform Your Communication?
            </h3>
            <p className="text-blue-100 mb-6 text-lg">
              Join thousands of businesses already using our SMS solutions to engage customers effectively
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/contact"
                className="inline-flex items-center justify-center bg-gradient-to-r from-blue-600 to-green-600 text-white px-8 py-3 rounded-lg font-semibold hover:from-blue-700 hover:to-green-700 shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 ease-in-out"
              >
                Contact Our Team
              </Link>
              {/* <Link
                to="/contact"
                className="inline-flex items-center justify-center border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-blue-600 shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 ease-in-out"
              >
                Contact Sales Team
              </Link> */}
            </div>
            <p className="text-yellow-200 mt-6 text-sm">
              Powered by Infinity Tech Africa. Create. Transform.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BulkSmsModules;